import {inject, Inject, Injectable, DOCUMENT} from '@angular/core';

import {Meta} from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class CanonicalService {
  private meta = inject(Meta)
  private document = inject(DOCUMENT)

  setCanonical() {
    const lastCanonical = this.document.querySelector('link[rel=\'canonical\']');
    if (lastCanonical) {
      this.document.head.removeChild(lastCanonical);
    }
    const link: HTMLLinkElement = this.document.createElement('link');
    link.setAttribute('rel', 'canonical');
    const canonical = this.document.URL.replace('http:', 'https:');
    link.setAttribute('href', canonical);
    this.document.head.appendChild(link);

    this.meta.removeTag('name=\'og:url\'');
    this.meta.removeTag('name=\'twitter:url\'');
    this.meta.addTag({
      property: 'og:url',
      content: canonical
    });
    this.meta.addTag({
      property: 'twitter:url',
      content: canonical
    });
  }
}
